export default "__VITE_ASSET__P6O_paJS__"